import React, { useState } from "react";

function Header() {

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };

    // State to track menu visibility
    const [isNavOpen, setIsNavOpen] = useState(false);

    // Toggle function
    const toggleNav = () => {
    setIsNavOpen((prev) => !prev);
    };

    return (
        <div className Name="main-top" id="home">
                {/* header */}
                <div className="headder">
                    <div className="logo"><a href="/home" style={{ color: 'inherit', textDecoration: 'none' }}>Adya Yoga</a></div>                    
                    <nav className={`nav ${isNavOpen ? 'active' : ''}`}>
                    <ul className="nav-links">
                        <li><a href="/home">Home</a></li>
                        <li><a href="/training-and-experiences">Training & Experience</a></li>
                        <li><a href="/yoga-and-meditation">Yoga & Meditation</a></li>
                        <li><a href="/healing-and-therapies">Healing & Therapies</a></li>
                        <li><a href="/sound-healing-journey">Sound Healing Journey</a></li>                        
                        <li><a href="/courses">Courses</a></li>                        
                        {/* More Section with Dropdown */}
                        <li className="dropdown">
                        <a className="dropbtn" onClick={toggleDropdown}>
                            More ▼
                        </a>
                        <ul className={`dropdown-content ${isDropdownOpen ? 'active' : ''}`}>                            
                            <li><a href="/online-sessions">Online Sessions</a></li>
                            <li><a href="/events-and-retreats">Event & Retreats</a></li>
                            <li><a href="contact">Contact</a></li>
                        </ul>
                        </li>
                    </ul>
                    </nav>   
                    <button class="menu-btn" onClick={toggleNav}>&#9776;</button>                 
                </div>
                {/* //header */}
                {/* banner */}    
            </div>
    );

}
export default Header;